import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/smarthomepanel/pc/');

export default function Comp({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('smarthomepanel');

    return (
        <div className={`${css.textImgA1} textImgA1`}>
            <div className="msg-box">
                <div className="msg-l">
                    <span className="ms1">{t('smart_home_panel.six_des_white')}</span>
                    <span className="ms2">{t('smart_home_panel.six_des_gray')}</span>
                </div>
                <div className="msg-r">
                    {t('smart_home_panel.ytdd_sec5_subtit_pc1')}
                    <div></div>
                    {t('smart_home_panel.ytdd_sec5_subtit_pc2')}
                </div>
            </div>
            <div className="msg-tips">{t('smart_home_panel.six_text')}</div>
            <div className="img-box">
                <EFPic name={["img_10.webp", "img_10.jpg"]} alt={t('Up to 7200W Output')} />
            </div>
        </div>
    );
}
